import { StoreType } from 'utils/connect';

import { UpdateAvatarCardLinkWidgetForm } from 'components/consumer-page-widgets/avatar-card-link-widget/UpdateAvatarCardLinkWidgetForm';
import { UpdateButtonArrayWidgetForm } from 'components/consumer-page-widgets/button-array-widget/UpdateButtonArrayWidgetForm';
import { UpdateCardLinkWidgetForm } from 'components/consumer-page-widgets/card-link-widget/UpdateCardLinkWidgetForm';
import { UpdateGridWidgetForm } from 'components/consumer-page-widgets/grid-widget/UpdateGridWidgetForm';
import { UpdateMetroAreaContainerWidgetForm } from 'components/consumer-page-widgets/metro-area-container-widget/UpdateMetroAreaContainerWidgetForm';
import { UpdateOfferingsPlatterWidgetForm } from 'components/consumer-page-widgets/offerings-platter-widget/UpdateOfferingsPlatterWidgetForm';
import { UpdateRowLayoutWidgetForm } from 'components/consumer-page-widgets/row-layout-widget/UpdateRowLayoutWidgetForm';
import { UpdateShopHeroWidgetForm } from 'components/consumer-page-widgets/shop-hero-widget/UpdateShopHeroWidgetForm';
import { assertNever } from '@tock/shared/utils/typeUtils';
import { consumer } from '@tock/coretypes';
import { fetchAllNamedConfigurations } from 'actions/ConsumerPageActions';
import { useAppDispatch } from 'state/hooks';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ClowncarBodyV2 from 'components/ClowncarBodyV2';
import ClowncarHeaderV2 from 'components/ClowncarHeaderV2';
import React, { FunctionComponent } from 'react';
import UpdateMarketingFeatureWidgetForm from 'components/consumer-page-widgets/marketing-feature-widget/UpdateMarketingFeatureWidgetForm';

const getWidgetFormForWidgetType = (
  widgetToEdit: consumer.NamedConfiguration,
  onComplete: () => void
) => {
  const widgetType = widgetToEdit.namedConfigurationConfig;

  if (!widgetType) {
    return null;
  }

  switch (widgetType) {
    case 'cardLinkWidgetConfig':
      return (
        <UpdateCardLinkWidgetForm
          selectedWidgetToEdit={widgetToEdit}
          onCompleteOrCancel={onComplete}
        />
      );
    case 'rowLayoutWidgetConfig':
      return (
        <UpdateRowLayoutWidgetForm
          selectedWidgetToEdit={widgetToEdit}
          onCompleteOrCancel={onComplete}
        />
      );
    case 'avatarCardLinkWidgetConfig':
      return (
        <UpdateAvatarCardLinkWidgetForm
          selectedWidgetToEdit={widgetToEdit}
          onCompleteOrCancel={onComplete}
        />
      );
    case 'shopHeroWidgetConfig':
      return (
        <UpdateShopHeroWidgetForm
          selectedWidgetToEdit={widgetToEdit}
          onCompleteOrCancel={onComplete}
        />
      );
    case 'buttonArrayWidgetConfig':
      return (
        <UpdateButtonArrayWidgetForm
          selectedWidgetToEdit={widgetToEdit}
          onCompleteOrCancel={onComplete}
        />
      );
    case 'gridWidgetConfig':
      return (
        <UpdateGridWidgetForm selectedWidgetToEdit={widgetToEdit} onCompleteOrCancel={onComplete} />
      );
    case 'marketingFeaturesWidgetConfig':
      return (
        <UpdateMarketingFeatureWidgetForm
          selectedWidgetToEdit={widgetToEdit}
          onCompleteOrCancel={onComplete}
        />
      );
    case 'collectionPageConfig':
      return <div>TODO</div>;
    case 'metroAreaWidgetConfig':
      return (
        <UpdateMetroAreaContainerWidgetForm
          selectedWidgetToEdit={widgetToEdit}
          onCompleteOrCancel={onComplete}
        />
      );
    case 'offeringsPlatterWidgetConfig':
      return (
        <UpdateOfferingsPlatterWidgetForm
          selectedWidgetToEdit={widgetToEdit}
          onCompleteOrCancel={onComplete}
        />
      );
    default:
      assertNever(widgetType);
  }
};

interface MatchParams {
  id: string;
}

export const EditConsumerPageWidgetRoute: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const { id } = useParams<MatchParams>();

  const namedConfigurationIdNumber = Number(id);

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(fetchAllNamedConfigurations());
  }, [dispatch]);

  const activeNamedConfigs = useSelector(
    (state: StoreType) => state.consumerPage.namedConfigurations
  ) as consumer.NamedConfiguration[];

  const history = useHistory();

  const widgetToEdit = activeNamedConfigs.find(
    (namedConfig) => namedConfig.id === namedConfigurationIdNumber
  );

  if (!widgetToEdit) {
    return null;
  }

  const form = getWidgetFormForWidgetType(widgetToEdit, () => history.goBack());

  return (
    <div className="Content">
      <ClowncarHeaderV2 heading={`Editing widget - ${widgetToEdit.name}`} />
      <div className="Main">
        <ClowncarBodyV2>{form}</ClowncarBodyV2>
      </div>
    </div>
  );
};
